import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  CircularProgress,
  Divider,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  TextField,
  Backdrop
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import {
  AddRefrenceDataList,
  PutRefrenceDataList,
  deleteItem
} from "../AdminSetting/adminaction";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(dashboardStyle);

const provinceOptions = ["Punjab", "Sindh"];

export default function StampDutyModel({
  setOpenModel,
  getdata,
  updateId,
  setUpdateId,
  togglebutton,
  settogglebutton,
  deleteId,
  setDeleteID,
  setSuccessMessage,
  setErrorMessage,
  getdataFromID,
  setGetDataFromID,
  setGetData
}) {
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [enable, setEnable] = useState(false);

  const [formState, setFormState] = useState({
    referenceId: 0,
    referenceKey: "Province",
    referenceCode: "",
    referenceText: "",
    referenceProp1: "",
    referenceProp2: "",
    referenceProp3: "",
    referenceProp4: "",
    isActive: true,
    VendorAccess: "",
    stampDuty: ""
  });

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setOpenModel(false);
    clearState();
  };

  const clearState = () => {
    setUpdateId("");
    setDeleteID("");
    settogglebutton("");
    setGetDataFromID("");
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (updateId) {
      PutRefrenceDataList(
        formState,
        setFormState,
        setSuccessMessage,
        setErrorMessage,
        setLoader,
        setGetData,
        handleClose
      );
    } else {
      AddRefrenceDataList(
        formState,
        setFormState,
        setLoader,
        setSuccessMessage,
        setErrorMessage,
        setGetData,
        handleClose
      );
    }
  };

  const Delete = () => {
    deleteItem(
      formState,
      setFormState,
      deleteId,

      setLoader,
      setSuccessMessage,
      setErrorMessage,
      setGetData,

      handleClose

    );
  };

  useEffect(() => {
    handleClickOpen();

    if (updateId || deleteId) {
      const record = getdata.find((item) => item.referenceId === getdataFromID);
      setFormState((prev) => ({
        ...prev,
        referenceId: record.referenceId,
        referenceKey: record.referenceKey || "Province", 
        referenceCode: record.referenceCode || "",
        referenceText: record.referenceText || "",
        referenceProp1: record.referenceProp1 || "",
        referenceProp2: record.referenceProp2 || "",
        referenceProp3: record.referenceProp3 || "",
        referenceProp4: record.referenceProp4 || "",
        isActive: record.isActive ? true : false,
        VendorAccess: record.VendorAccess || "",
        stampDuty: record.stampDuty || ""
      }));
    } else if (togglebutton) {
      const toggle = getdata.find((item) => item.referenceId === togglebutton);
      setFormState((prev) => ({
        ...prev,
        referenceId: toggle.referenceId,
        referenceKey: toggle.referenceKey || "Province",
        referenceCode: toggle.referenceCode || "",
        referenceText: toggle.referenceText || "",
        referenceProp1: toggle.referenceProp1 || "",
        referenceProp2: toggle.referenceProp2 || "",
        referenceProp3: toggle.referenceProp3 || "",
        referenceProp4: toggle.referenceProp4 || "",
        isActive: toggle.isActive ? true : false,
        VendorAccess: toggle.VendorAccess || "",
        stampDuty: toggle.stampDuty || ""
      }));
      //setEnable(toggle?.isActive);
    }
  }, [updateId, deleteId, togglebutton]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      {deleteId ? (
        <DialogContent>
          <Backdrop open={loader} style={{ zIndex: 1300 }}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box textAlign="center">
            <HelpOutline fontSize="large" color="secondary" />
            <Typography variant="h5" mt={2}>
              Are you sure you want to delete this entry?
            </Typography>
            <Box mt={3}>
              <Button variant="outlined" color="secondary" onClick={handleClose}>
                No
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={Delete}
                style={{ marginLeft: "20px" }}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </DialogContent>
      ) : (
        <form onSubmit={submitHandler}>
              <DialogTitle
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                Stamp Duty
              </DialogTitle>
          <Divider />
          <DialogContent>
            <Backdrop open={loader} style={{ zIndex: 1300 }}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2} pb={3}>
              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel>Province</InputLabel>
                  <Select
                    required
                    label="Province"
                    name="referenceText"
                    value={formState.referenceText}
                    onChange={changeHandler}
                  >
                    {provinceOptions.map((prov) => (
                      <MenuItem key={prov} value={prov}>
                        {prov}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  label="Stamp Duty"
                  name="stampDuty"
                  type="number"
                  inputProps={{ min: "0", step: "0.01" }}
                  value={formState.stampDuty}
                  onChange={changeHandler}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button variant="outlined" color="error" onClick={handleClose}>
              Cancel
            </Button>
                {updateId ? (
                  <Button
                    color="success"
                    variant="contained"
                    type="submit"
                  // onClick={()=>}
                  >
                    Updated
                  </Button>
                ) : (
                  <Button
                    color="success"
                    variant="contained"
                    type="submit"
                  //   onClick={add_role_data}
                  >
                    Save
                  </Button>
                )}
          </DialogActions>
        </form>
      )}
    </Dialog>
  );
}
